import { Eye } from '@phosphor-icons/react';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { getAgeingModalAction, loaderAction } from '../../redux/actions/Index';
import Table from '../Table';
import EmptyTable from '../errorComponents/EmptyTable';
import axios from 'axios';
import { environment } from '../../env';
import moment from 'moment';
import { useMemo } from 'react';

const TenantAgeingModal = ({ data }) => {

    const ageingToggle = useSelector((state) => state?.ModalReducer?.agemodalToggle);
    const [tenantdetails, setTenantDetails] = useState([]);
    const dispatch = useDispatch()
    const userProject = useSelector((state) => state?.ModalReducer?.userproject);

    const toggle = () => {
        dispatch(getAgeingModalAction(false))
    };

    const dateDiff = (data, id) => {
        const curDate = moment().format('YYYY-MM-DD');
        const newDate = moment(data).format('YYYY-MM-DD');
        var today = moment(newDate)
        var rentEndDate = moment(curDate)
        let dateDif = today.diff(rentEndDate, 'days')
        if (dateDif >= 0) {
            return dateDif
        } else {
            const tenantdetailsdata = tenantdetails.filter((curElem) => {
                return curElem.id !== id
            })
            setTenantDetails(tenantdetailsdata)
        }
    }

    const columns = [
        {
            name: 'Remaining day',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={`${(dateDiff(row.rent_end_date) <= 60) ? 'icon-bg-green icon-color-green ':'icon-bg-red icon-color-red '} ${(dateDiff(row.rent_end_date) <= 30) && 'icon-bg-yellow icon-color-yellow'} ${(dateDiff(row.rent_end_date) <= 10) && 'icon-bg-red icon-color-red'}   rounded-pill status-box rounded fs-4`}>{dateDiff(row.rent_end_date, row.id) + ' ' + "Days"}</label>
            </div>,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Tenant Name',
            selector: row => row.proposal.name_of_company,
            wrap: true,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building',
            selector: row => row.building.building_no,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Email',
            selector: row => row.proposal.company_email,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Contact No',
            selector: row => row.proposal.contact_number,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.proposal.required_area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Aggreement Start Date',
            selector: row => moment(row.aggrement_start_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Rent End Date',
            selector: row => moment(row.rent_end_date).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }
    ]

    const getTenant = async () => {
        dispatch(loaderAction(true))
        try {
            await axios.get(`${environment.baseUrl}add-gala-tenant/`).then((customerdata) => {
                let array = []
                let filteredData = customerdata.data.filter((data) => data.project.id == userProject)
                filteredData?.map((data) => {
                    let date1 = moment(data.aggrement_end_date);
                    let date2 = moment().format('YYYY-MM-DD');
                    let days = date1.diff(date2, 'days')
                    if (days <= 90) {
                        array.push(data)
                    }
                })
                setTenantDetails(array);
                dispatch(loaderAction(false))
            })
        }
        catch (err) {
            dispatch(loaderAction(false))
            console.log(err);
        }
    }

    useMemo(() => {
        if (ageingToggle == true) {
            getTenant()
        }
    }, [ageingToggle])

    return (
        <>
            {/* <button onClick={toggle} className="icon-bg-green border-0 p-3 py-3 rounded"><Eye size="26" className='icon-color-green'/></button> */}
            <Modal className='border-5' isOpen={ageingToggle} toggle={toggle} size="xl" centered>
                <ModalHeader className='bg-base-color ' toggle={toggle} >
                    <div className="d-flex justify-content-around ">
                        <h1 className='title-font-bold text-base-white'>Tenant Ageing Details <span className='fs-2 text-base-white base-font-600 ms-3'>{`(90 Days)`}</span></h1>
                    </div>
                </ModalHeader>
                <ModalBody className='bg-white px-5 py-5 d-flex justify-content-center flex-column'>
                    <div className="bg-white p-5 rounded-5 mb-5 shadow-sm">
                        {tenantdetails?.length != 0 ? <Table columns={columns} data={tenantdetails} /> : <EmptyTable />}
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
};


export default TenantAgeingModal